// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--87dd8";
export var headingContainer = "index-module--heading-container--76ad8";
export var highlight = "index-module--highlight--65d54";
export var highlightLine = "index-module--highlight-line--dd285";
export var image1 = "index-module--image-1--4649f";
export var image2 = "index-module--image-2--dde10";
export var imageContainer = "index-module--image-container--e5894";